import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13 17L12.375 15.5C11.5666 14.6282 10.7012 14 8.50001 14C6.29879 14 5.43337 14.6282 4.625 15.5L4 17M18 15V9M21 12H15M8.5 11C7.11929 11 6 9.88071 6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5C11 9.88071 9.88071 11 8.5 11Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUserPlus;
